import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/Default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/layouts/Login.vue").then(m => m.default || m))
}